import { userConstants } from './constantData';

export const TERMS_OF_SERVICE_DATA = {
  terms_page: {
    page_view: {
      hash: 'p-002.054.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
      ],
    },
    accept_terms: {
      hash: 'e-002.054.042.000.000.050',
      event: 'interactions',
      dimensions: [
        ...userConstants,
      ],
    },
    page_view_error: {
      hash: 'p-002.009.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
      ],
    },
    continue_error_terms: {
      hash: 'e-002.009.042.000.000.050',
      event: 'interactions',
      dimensions: [
        ...userConstants,
      ],
    },
  },
};
